<template>
    <div class="related">
        <div class="related-title">{{pageTitle}}</div>
        <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
            <tr>
                <th style="width: 50px;">序号</th>
                <th style="width: 200px;">项目编号</th>
                <th style="min-width: 100px;">时间</th>
                <th style="min-width: 460px;">项目名称</th>
                <th style="min-width: 150px;">审核类型</th>
                <th style="min-width: 160px;">建设单位</th>
                <th style="min-width: 150px;">审批单位</th>
            </tr>
            <tr v-for="(list, i) in paginatedData" :key="list.id">
                <td>{{ i + 1 + (currentPage - 1) * pageSize }}</td>
                <td style="white-space: nowrap;">{{ list.projectCode }}</td>
                <td>{{ list.date.slice(0, 10) }}</td>
                <td><span class="active-color" @click="handlerLinkTo(list)">{{ list.projectName }}</span></td>
                <td>{{ list.title }}</td>
                <td>{{ list.companyName }}</td>
                <td>{{ list.approveUnitName }}</td>
            </tr>
        </table>
        <div class="pagination-wrapper text-right my-2">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" background />
        </div>

    </div>
</template>

<script>
export default {

    data() {
        return {
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            paginatedData: [], // 当前页要展示的数据 (真正绑定给表格的数据)
            rawData: [], // 原始数据
        }
    },
    props: {
        relatedByData: {
            type: Array,
            default: () => []
        },
        pageTitle: {
            type: String,
            default: '关联项目'
        },
        pageType: {
            type: Number,
            default: 1
        }
    },
    watch: {
        relatedByData: {
            immediate: true,  // 立即执行一次，解决初始化问题
            handler(newVal) {
                this.rawData = newVal || [];
                this.total = this.rawData.length;
                this.currentPage = 1;  // 数据变化时重置到第一页
                this.updatePaginatedData();
            }
        }
    },
    created() {
        this.rawData = this.relatedByData;
        
    },
    mounted() {
        this.total = this.relatedByData.length;
        this.updatePaginatedData();
    },
    methods: {
        handlerLinkTo(list) {
            switch (list.dataType) {
                case 1:
                    this.handlerLinkLocal('/examineNotice/detail?id=' + list.id);
                    break;
                case 2:
                    this.handlerLinkLocal('/ApprovalNotice/detail?id=' + list.id);
                    break;
                case 3:
                    this.handlerLinkLocal('/RecordPublic/detail?id=' + list.id);
                    break;
                case 4:
                    this.handlerLinkLocal('/EiaReport/detail?id=' + list.id);
                    break;
                case 5:
                    this.handlerLinkLocal('/EnergyNotice/detail?id=' + list.id);
                    break;
                case 6:
                    this.handlerLinkLocal('/LandPreapproval/detail?id=' + list.id);
                    break;
                case 7:
                    this.handlerLinkLocal('/landSearch/detail?id=' + list.id);
                    break;
                case 8:
                    this.handlerLinkLocal('/LandPermit/detail?id=' + list.id);
                    break;
                case 9:
                    this.handlerLinkLocal('/ConstructionPermit/detail?id=' + list.id)
                    break;
                case 10:
                    this.handlerLinkLocal('/tenderingBidding/detail?id=' + list.id);
                    break;
                case 11:
                    this.handlerLinkLocal('/buildPermit/detail?id=' + list.id);
                    break;
            }
        },
        // 2. 核心分页逻辑：计算并截取当前页的数据
        updatePaginatedData() {
            // 计算起始索引 (例如：第2页，每页100条 -> 从索引100开始)
            const start = (this.currentPage - 1) * this.pageSize;
            // 计算结束索引 (例如：从100开始，取100条 -> 到索引200结束，不包含200)
            const end = start + this.pageSize;

            // 使用 slice 截取数组
            this.paginatedData = this.rawData.slice(start, end);
            console.log('pageType', this.pageType);
            console.log('截取数组', this.paginatedData);
        },
        // 3. 每页条数改变时触发 (例如从100条切换到50条)
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.currentPage = 1; // 重置回第一页
            this.updatePaginatedData();
        },
        // 4. 当前页码改变时触发 (点击页码按钮)
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.updatePaginatedData();
        },
    },
}
</script>

<style lang="scss" scoped>
.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 10px;
        border: 1px solid #eee;
        text-align: center;
    }
}
</style>